// Componente de skeleton para la creación de reglas - Skeleton component for rule creation
// Muestra placeholders que respetan la estructura de los bloques del formulario
import { SectionBox } from '@shared/components/ui/SectionBox';
import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

export const CreateRuleSkeleton = () => {
  return (
    <div className="p-6 space-y-6" data-testid="create-rule-skeleton">
      {/* Header Buttons Skeleton - Skeleton de los botones del header */}
      <div className="flex justify-end absolute top-1 right-4 gap-2 z-10">
        <Skeleton className="h-10 w-24 bg-hover-press" />
        <Skeleton className="h-10 w-32 bg-hover-press" />
      </div>

      {/* Rule Name Section Skeleton - Skeleton de la sección de nombre */}
      <SectionBox>
        <Skeleton className="h-5 w-32 rounded-full mb-3 bg-hover-press" />
        <Skeleton className="h-10 w-full mb-3 bg-hover-press" />
        <Skeleton className="h-4 w-96 rounded-full bg-hover-press" />
      </SectionBox>

      {/* Rule Conditions Section Skeleton - Skeleton de la sección de condiciones */}
      <SectionBox>
        <Skeleton className="h-6 w-48 rounded-full mb-3 bg-hover-press" />

        {/* Switch Match All Skeleton - Skeleton del switch match all */}
        <div className="flex items-center gap-2 mb-3">
          <Skeleton className="h-5 w-10 rounded-full bg-hover-press" />
          <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
        </div>

        {/* Condition Rows Skeleton - Skeleton de las filas de condiciones */}
        <div className="space-y-4">
          {[1, 2].map((index) => (
            <div
              key={index}
              className="flex flex-col sm:flex-row items-center gap-4 border-b border-card-border py-2 mb-3 sm:mb-0"
            >
              {/* Campo - Field */}
              <div className="w-full">
                <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
              </div>
              {/* Operador - Operator */}
              <div className="w-full">
                <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
              </div>
              {/* Valor - Value */}
              <div className="w-full">
                <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
              </div>
              {/* Botón eliminar - Delete button */}
              <div className="w-full sm:w-auto">
                <Skeleton className="h-10 w-10 rounded-md bg-hover-press" />
              </div>
            </div>
          ))}
        </div>

        {/* Botón Agregar Condición - Add Condition Button */}
        <div className="flex justify-end mt-3">
          <Skeleton className="h-9 w-40 bg-hover-press" />
        </div>
      </SectionBox>

      {/* Rule Actions Section Skeleton - Skeleton de la sección de acciones */}
      <SectionBox>
        <Skeleton className="h-6 w-32 rounded-full mb-2 bg-hover-press" />
        <div className="grid sm:grid-cols-2 gap-4">
          {/* Enviar con - Send with */}
          <div>
            <Skeleton className="h-4 w-24 rounded-full mb-2 bg-hover-press" />
            <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
          </div>
          {/* Producto - Product */}
          <div>
            <Skeleton className="h-4 w-20 rounded-full mb-2 bg-hover-press" />
            <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
          </div>
        </div>
      </SectionBox>
    </div>
  );
};
